// Footer link groups: collapsible <details> on mobile, always open on desktop.
class SResponsiveDetails extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.query = window.matchMedia('(min-width: 48rem)');

    const apply = () => {
      this.querySelectorAll('details').forEach((details) => { details.open = this.query.matches; });
    };
    apply();
    this.query.addEventListener('change', apply, { signal });

    this.addEventListener('click', (event) => {
      if (this.query.matches && event.target.closest('summary')) event.preventDefault();
    }, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

customElements.define('s-responsive-details', SResponsiveDetails);
